import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';

const UserDetails = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UserDetails" */ '@confluence/site-permissions/entry-points/UserDetails.ts'
			)
		).UserDetails,
});

export const GlobalPermissionUserDetailsRoute: {
	({ params: { accountId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = ({ params: { accountId } }: RouteMatch): React.JSX.Element => (
	<UserDetails accountId={accountId} />
);

GlobalPermissionUserDetailsRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'sitePermissionsUserDetailsScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
